<template>
  <div>
    <component-header
      title="View Advertisement"
      :hasSearch="false"
      :hasReload="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.push('/advertisement')"
    />
    <b-card>
      <div class="my-2 mb-4 ml-4 mr-4">
        <h2 style="color: #2c8ef8">Basic Details</h2>
        <b-row>
          <b-col md="4">
            <h5 class="h5-text">
              Advertisement Type :
              <span class="span-text">{{ adDetails.type }}</span>
            </h5>
            <h5 class="h5-text">
              Placement :
              <span class="span-text">{{ adDetails.placement }}</span>
            </h5>
            <!-- <div>
              <h5 class="h5-text">
                Tags :
                <span
                  class="span-text"
                  v-for="tag in adobject.tag"
                  :key="tag"
                  >{{ tag }}</span
                >
              </h5>
            </div> -->
          </b-col>
          <b-col md="4">
            <h5 class="h5-text">
              Start Date :
              <span class="span-text">{{ 
                formateDate(adDetails.duration.startDate)
              }}</span>
            </h5>
            <h5 class="h5-text">
              End Date :
              <span class="span-text">{{formateDate(adDetails.duration.endDate) }}</span>
            </h5>
            <div v-for="dataObj, index in adDetails.data" :key="index">
              <h5 class="h5-text" v-if="adDetails.type === 'VIDEO' && dataObj.navigateTo">
                Navigate To :
                <span class="span-text"> {{ dataObj.navigateTo}}</span>
              </h5>
              <h5 class="h5-text" v-if="adDetails.type === 'SLIDER' && dataObj.navigateTo">
                Navigate To :
                <span class="span-text"> {{ dataObj.navigateTo}}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div v-for="dataObj, index in adDetails.data" :key="index">
              <h5 class="h5-text" v-if="adDetails.type === 'BANNER'">
                Image:
                <img
                  v-if="dataObj.url.fileUrl && dataObj.url.fileUrl.length > 1"
                  :src="dataObj.url.fileUrl"
                  alt=""
                  class="w-50"
                />
              </h5>
              <h5 class="h5-text" v-if="adDetails.type === 'VIDEO'">
                Video:
                <video
                  v-if="dataObj.video.type == 'UPLOADED'"
                  :src="dataObj.video.url"
                  alt=""
                  class="w-50"
                />
                <span v-if="dataObj.video.type == 'YOUTUBE'">{{ dataObj.video.url }}</span>
              </h5>
              <h5 class="h5-text" v-if="adDetails.type === 'SLIDER' && dataObj.video">
                Video:
                <video
                  v-if="dataObj.video && dataObj.video.type == 'UPLOADED'"
                  :src="dataObj.video.url"
                  alt=""
                  class="w-50"
                />
                <span v-if="dataObj.video.type == 'YOUTUBE'">{{ dataObj.video.url }}</span>
              </h5>
              <h5 class="h5-text" v-if="adDetails.type === 'SLIDER' && dataObj.url">
                Image:
                <img
                  v-if="dataObj.url.fileUrl && dataObj.url.fileUrl.length > 1"
                  :src="dataObj.url.fileUrl"
                  alt=""
                  class="w-50"
                />
              </h5>
            </div>
            <h5 class="h5-text">
              Icon : <img :src="adDetails.icon.fileUrl" alt="" class="w-50" />
            </h5>
          </b-col>
        </b-row>
        <hr style="border-top: 1px solid #727cf5" class="mt-4" />
        <div>
          <h2 style="color: #2c8ef8; margin-bottom: 20px" class="mt-3">
            Address And Target
          </h2>
          <b-row>
            <b-col md="4">
              <h5 class="h5-text">
                country :
                <span class="span-text">{{
                  adDetails.target.address.country
                }}</span>
              </h5>
              <h5 class="h5-text">
                Visibility :
                <span
                >
                  {{ adDetails.target.visibility.type }}&nbsp;{{ adDetails.target.visibility.id }}
                </span>
              </h5>
            </b-col>
            <b-col md="4">
              <h5 class="h5-text">
                state :
                <span class="span-text">{{
                  adDetails.target.address.state
                }}</span>
              </h5>
              <h5 class="h5-text">
                Mininum Age Group :
                <span class="span-text">{{
                  adDetails.target.ageGroup.min
                }}</span>
              </h5>
            </b-col>
            <b-col md="4">
              <h5 class="h5-text">
                City :
                <span class="span-text">{{
                  adDetails.target.address.city
                }}</span>
              </h5>
              <h5 class="h5-text">
                Maximum Age Group :
                <span class="span-text">{{
                  adDetails.target.ageGroup.max
                }}</span>
              </h5>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import cInput from "@/components/FormElements/CustomInput";
import DatePicker from "vuejs-datepicker";
import ebSelect from "@/components/FormElements/Select.vue";
import locationMixins from "@/mixins/addressLocation";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import ComponentHeader from "@/components/componentHeader";

export default {
  name: "viewAdvertisement",
  data() {
    return {
    };
  },
  mixins: [locationMixins],
  components: {
    cInput,
    DatePicker,
    ebSelect,
    ComponentHeader,
  },
  methods: {
    ...mapActions({
      AdDetails: "advertisement/fetchAdDetails",
    }),
    formateDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
  computed: {
    ...mapGetters({
      adDetails: "advertisement/GetAdDetails",
    }),
  },
  async mounted() {
    await this.AdDetails(this.$route.params.id);
  },
};
</script>
<style scoped>
.location-search {
  border-radius: 0rem;
  color: rgb(0, 0, 0);
  box-shadow: none !important;
  font-family: "Lato";
  height: 39px !important;
  border: 1px solid #dee2e6;
  padding-left: 10px;
  width: 100%;
  font-size: small;
}
[btn-color="primary"] {
  height: 41px;
  background-color: #727cf5;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: "Lato";
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  height: 43px;
  width: 139px;
  background-color: #727cf5;
  color: white;
}

.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}
[col-4="image"] {
  background-color: aliceblue !important;
}
[btn-back="primary"] {
  background-color: #727cf5 !important;
  margin: 0px;
  height: 41px;
  color: white;
}
.img-avatar {
  margin-top: 150px !important;
}
</style>
<style>
.span-text {
  font-size: 15px;
  font-weight: normal;
  line-height: 24px;
}
.h5-text {
  font-size: 15px;
  line-height: 17px;
}
</style>
